import log from 'loglevel';

import { environment } from '@ts/shared/util-environment';

log.setLevel(environment.logLevel);

export const logger = log;
